import React, { Fragment } from "react";
import SidebarWrapper from "./sidebar.style";
import Radium from "radium";
import NavList from "components/sidebar/NavList";
import { sidebarData, adminsidebarData } from "util/data/sidebar";
import { Scrollbars } from "react-custom-scrollbars";
import minilogo from "../../assets/images/logo.png";
import logo from "../../assets/images/icon_logo.svg";
import { connect } from "react-redux";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import moment from "moment";

// import IntlMessages from "util/intlMessages";
const merchantSideBarData = [
  {
    name: "Dashboard",
    iconClass: "fas fa-chalkboard",
    routepath: "/dashboard"
  },
  {
    name: "Users",
    iconClass: "fas fa-user",
    routepath: "/users"
  },
  {
    name: "Call Logs",
    iconClass: "fas fa-phone",
    routepath: "/call-logs"
  },
  {
    name: "Subscription",
    iconClass: "fas fa-dollar-sign",
    routepath: "/subscription"
  },
  {
    name: "Subscription History",
    iconClass: "fas fa-dollar-sign",
    routepath: "/subscription-history"
  }
  // {
  //   name: "Report",
  //   iconClass: "fas fa-file",
  //   routepath: "/report"
  // }
];

const Sidebar = props => {
  // console.log("user check in side bar", props.user);
  let SidebarData = props?.user?.is_superadmin
    ? sidebarData
    : merchantSideBarData
    ? props?.user?.is_admin
      ? merchantSideBarData.filter(e => {
          return e.routepath === "/users";
        })
      : merchantSideBarData
    : merchantSideBarData;

  let listNameStyle;
  let sidebar;
  let sideScrollStyle;

  const {
    mini,
    drawerWidth,
    miniDrawerWidth,
    onMouseEnter,
    onMouseLeave,
    sidebarTheme,
    layoutTheme,
    closeDrawer,
    themeSetting,
    user
  } = props;

  // console.log("user", user);

  let todayDate = moment(new Date()).utc();
  let differenceDate = moment(user.is_free_expiryDate).diff(todayDate, "days");
  let totalDays = (differenceDate * 100) / process.env.REACT_APP_FREE_TRIAL_DAY;
  // console.log("totalDays", totalDays);

  if (
    themeSetting.toolbarAlignValue === "above" &&
    themeSetting.footerAlignValue === "above"
  ) {
    sideScrollStyle = {
      zIndex: 5,
      height: "calc(100vh - 190px)"
    };
  } else if (themeSetting.toolbarAlignValue === "above") {
    sideScrollStyle = {
      zIndex: 5,
      height: "calc(100vh - 145px)"
    };
  } else if (themeSetting.footerAlignValue === "above") {
    sideScrollStyle = {
      zIndex: 5,
      height: "calc(100vh - 128px)"
    };
  } else {
    sideScrollStyle = {
      zIndex: 5,
      height: "calc(100vh - 75px)"
    };
  }

  if (themeSetting.sidebarTransParentValue === "on") {
    sidebar = {
      backgroundImage: `linear-gradient(0deg,rgba(0, 0, 0, 0.8),rgba(0, 0, 0, 0.9)),url(${themeSetting.transparentImage})`,
      backgroundRepeat: "no-repeat, repeat",
      backgroundPosition: "center",
      backgroundSize: "cover",
      width: mini ? miniDrawerWidth : drawerWidth,
      "@media (max-width: 991.98px)": {
        width: mini ? 0 : drawerWidth
      }
    };
  } else {
    sidebar = {
      width: mini ? miniDrawerWidth : drawerWidth,
      background: sidebarTheme.backgroundColor,
      "@media (max-width: 991.98px)": {
        width: mini ? 0 : drawerWidth
      }
    };
  }

  const closeIcon = {
    "@media (max-width: 991.98px)": {
      display: "block"
    }
  };

  if (mini) {
    listNameStyle = {
      opacity: miniDrawerWidth === drawerWidth ? 1 : 0,
      transform:
        miniDrawerWidth === drawerWidth
          ? "translateZ(0)"
          : "translate3d(-25px,0,0)"
    };
  } else {
    listNameStyle = {
      opacity: !mini ? 1 : 0,
      transform: !mini ? "translateZ(0)" : "translate3d(-25px,0,0)"
    };
  }

  return (
    <SidebarWrapper
      themeSetting={themeSetting}
      sidebarTheme={sidebarTheme}
      layoutTheme={layoutTheme}
      mini={mini}
      miniDrawerWidth={miniDrawerWidth}
      drawerWidth={drawerWidth}
    >
      {!mini && <div className="sidebar-overlay" onClick={closeDrawer()}></div>}
      <div
        id="sidebar"
        className="sidebar sideBack"
        style={sidebar}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        <div className="sidebar-header">
          {/* <NavLink to={"/"} className="simple-text logo-mini">
            <div className="logo-img">
              <img src={iconDemo} alt="react-logo" />
            </div>
          </NavLink> */}
          <div className="logo-text simple-text fs-20 bold-text">
            <img
              src={mini && miniDrawerWidth !== "260px" ? logo : minilogo}
              alt=""
            />
          </div>
        </div>
        <div
          className="close-drawer-icon"
          style={closeIcon}
          onClick={closeDrawer()}
        >
          <i className="fas fa-times-circle" />
        </div>
        <Scrollbars
          autoHide
          style={sideScrollStyle}
          renderThumbVertical={({ style, ...props }) => (
            <div {...props} className="sidebar-scrollbar-style" />
          )}
          renderThumbHorizontal={({ style, ...props }) => <div {...props} />}
          renderTrackVertical={({ style, ...props }) => (
            <div
              {...props}
              style={{
                ...style,
                zIndex: 5,
                position: "absolute",
                width: "6px",
                right: "2px",
                bottom: "2px",
                top: "2px",
                borderRadius: "3px"
              }}
            />
          )}
        >
          <div className="sidebar-wrapper">
            <ul className="nav">
              {SidebarData.map((list, i) => {
                return (
                  <Fragment key={i}>
                    {list.type && list.type === "heading" ? (
                      (!mini || miniDrawerWidth === drawerWidth) && (
                        <div className="sidelist-header-name">
                          {
                            <Fragment>
                              {/* <IntlMessages id= /> */}
                              {list.name}
                              {list.hasOwnProperty("isNew") && list["isNew"] && (
                                <span
                                  style={{
                                    right: "23px"
                                  }}
                                  className="new-update-tag fs-13 bold-text"
                                >
                                  New
                                </span>
                              )}
                            </Fragment>
                          }
                        </div>
                      )
                    ) : (
                      <NavList
                        listNameStyle={listNameStyle}
                        list={list}
                        mini={mini}
                        miniDrawerWidth={miniDrawerWidth}
                        drawerWidth={drawerWidth}
                        {...props}
                      />
                    )}
                  </Fragment>
                );
              })}
            </ul>
            {user?.is_free_trail && (
              <>
                <ul
                  className={
                    mini && miniDrawerWidth !== "260px"
                      ? "d-none"
                      : "free-trial-ul"
                  }
                >
                  <div
                    className={
                      mini && miniDrawerWidth !== "260px"
                        ? "d-none"
                        : "progress-bar"
                    }
                  >
                    <CircularProgressbar
                      value={totalDays}
                      text={`${differenceDate}`}
                    />
                    <span className="free-text">Free Trail Days remaining</span>
                  </div>
                </ul>
              </>
            )}
          </div>
        </Scrollbars>
      </div>
    </SidebarWrapper>
  );
};

const mapStateToProps = state => {
  // console.log(state);
  // console.log("state", state);
  return {
    ...state.themeChanger,
    user: state.auth.user
  };
};

export default connect(mapStateToProps, null)(Radium(Sidebar));
// export default ;
